import { FC, useMemo } from "react";
import { Icon, Stack, Typography } from "@mui/material";
import { useAppSelector } from "../../../../../../../../store/hooks";
import { cleanResourcesTotalEMSSelector } from "../../../../../../../../store/clean/selectors/cleanResourcesTotalEMSSelector";
import { money } from "../../../../../../../../utils/numeral/money";
import { ResourceType } from "../../../../../../../../services/cloudchipr.api";
import { IconByResourceType } from "../../../../../../account/components/navigation/IconByResourceType";
import { resourceServices } from "../../../../../../../../utils/constants/resources/resources";
import { cleanResourcesGridDataCountSelector } from "../../../../../../../../store/clean/selectors/cleanResourcesGridDataCountSelector";
import { resourceGroups } from "../../../../../../../../utils/constants/resources/resourceGroups";
import { getResourceTypeName } from "../../../../../../../../utils/helpers/resources/getResourceTypeName";
import { getProviderTypeByResourceType } from "../../../../../../../../utils/helpers/providers/getProviderTypeByResourceType";

interface CleanDescriptionSectionProps {
  resourceType: ResourceType;
}
export const CleanDescriptionSection: FC<CleanDescriptionSectionProps> = ({
  resourceType,
}) => {
  const totalEms = useAppSelector(cleanResourcesTotalEMSSelector);

  const cleanResourcesCount = useAppSelector(
    cleanResourcesGridDataCountSelector,
  );

  const serviceType = useMemo(() => {
    const provider = getProviderTypeByResourceType(resourceType);

    if (!provider) {
      return resourceType;
    }

    const groups = resourceGroups.get(provider);

    if (!groups) {
      return resourceType;
    }

    return (
      groups.find((group) => {
        return (
          group.value === resourceType ||
          group.resourceTypes.includes(resourceType)
        );
      })?.value ?? resourceType
    );
  }, [resourceType]);

  return (
    <Stack px={3} pt={3} pb={2} spacing={3}>
      <Typography
        component="span"
        variant="body1"
        color="text.primary"
        fontWeight="bold"
      >
        {money(totalEms)} Monthly Price
      </Typography>
      <Stack direction="row" alignItems="center">
        {resourceServices.has(serviceType) && (
          <Icon
            sx={{
              alignSelf: "start",
              color: "primary.main",
              minWidth: 30,
              filter: "grayscale(1)",
            }}
          >
            <IconByResourceType resourceType={serviceType} />
          </Icon>
        )}
        <Typography sx={{ m: 0 }} variant="body2" fontWeight={500}>
          {getResourceTypeName(resourceType, {
            service: true,
            singular: true,
            type: "abbreviation",
          })}{" "}
          - {cleanResourcesCount}{" "}
          {getResourceTypeName(resourceType, {
            singular: cleanResourcesCount === 1,
          })}
        </Typography>
      </Stack>
    </Stack>
  );
};
